var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Link } from 'react-router-dom';
import APInput from '../common/APInput';
import APPasswordInput from '../common/APPasswordInput/APPasswordInput';
import APButton from '../common/APButton';
import { required, email, matchingPassword, validatePassword } from '../../helpers/formValidations';
import { renderFormInputs } from '../../helpers/formGeneratorHelper';
import path from '../../helpers/path';
import passwordScore from '../../helpers/passwordScore';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import { defaultPath } from '../../routeTemplates';
import { styleNames } from '../../propTypes/commonComponent';
import '../../styles/components/common/StandaloneForm.css';
import './SimpleSignupFormComponent.css';
var baseClasses = getBEMClasses('standalone-form');
var signupFormClasses = getBEMClasses('signup-form');
var SimpleSignupFormComponent = function (_Component) {
  _inherits(SimpleSignupFormComponent, _Component);
  function SimpleSignupFormComponent() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, SimpleSignupFormComponent);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SimpleSignupFormComponent.__proto__ || Object.getPrototypeOf(SimpleSignupFormComponent)).call.apply(_ref, [this].concat(args))), _this), _this.getPasswordStrength = function () {
      var _this2 = _this,
        context = _this2.context;
      var score = passwordScore(_this.props.passwordValue);
      var passwordStrengthValues = {
        0: context.t('Very Weak'),
        1: context.t('Weak'),
        2: context.t('Medium'),
        3: context.t('Strong'),
        4: context.t('Very Strong')
      };
      return passwordStrengthValues[score];
    }, _this.handleChange = function () {
      if (_this.props.errorMsg) {
        _this.props.clearSignupError();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(SimpleSignupFormComponent, [{
    key: 'render',
    value: function render() {
      var context = this.context;
      var _props = this.props,
        handleSubmit = _props.handleSubmit,
        errorMsg = _props.errorMsg,
        submitting = _props.submitting,
        pristine = _props.pristine,
        passwordValue = _props.passwordValue,
        invalid = _props.invalid,
        done = _props.done,
        useEmailAsUsername = _props.useEmailAsUsername,
        additionalFields = _props.additionalFields;
      if (done) {
        return React.createElement('p', {
          className: '' + baseClasses('success')
        }, context.t('Thanks for signing up, please check your inbox for a confirmation email'));
      } else {
        return React.createElement('form', {
          onSubmit: handleSubmit,
          className: baseClasses('form') + ' ' + signupFormClasses('form')
        }, React.createElement('div', {
          className: signupFormClasses('wrapper')
        }, React.createElement('div', {
          className: signupFormClasses('container')
        }, !useEmailAsUsername && React.createElement(APInput, {
          type: 'text',
          name: 'username',
          label: context.t('Username'),
          validate: [required],
          customClass: signupFormClasses(),
          onChange: this.handleChange
        }), React.createElement(APInput, {
          type: 'text',
          name: 'email',
          label: context.t('Email'),
          validate: [required, email],
          customClass: signupFormClasses(),
          onChange: this.handleChange
        }), React.createElement(APPasswordInput, {
          type: 'password',
          name: 'password',
          label: context.t('Password'),
          validate: [required],
          info: passwordValue && this.getPasswordStrength(),
          customClass: signupFormClasses(),
          onChange: this.handleChange
        }), React.createElement(APPasswordInput, {
          type: 'password',
          name: 'matchingPassword',
          label: context.t('Retype Password'),
          classes: 'signup',
          validate: [required, matchingPassword, validatePassword],
          customClass: signupFormClasses(),
          onChange: this.handleChange
        }), renderFormInputs(additionalFields, signupFormClasses(), context), errorMsg && React.createElement('p', {
          className: baseClasses('error') + ' ' + signupFormClasses('error')
        }, errorMsg))), React.createElement('div', {
          className: signupFormClasses('footer')
        }, React.createElement(APButton, {
          type: 'submit',
          disabled: pristine || submitting || invalid,
          customClass: baseClasses() + ' ' + signupFormClasses(),
          styleName: styleNames.additive
        }, submitting ? context.t('Processing...') : context.t('Sign Up'))));
      }
    }
  }]);
  return SimpleSignupFormComponent;
}(Component);
SimpleSignupFormComponent.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};
SimpleSignupFormComponent.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  referrer: PropTypes.string,
  search: PropTypes.string,
  shouldRedirect: PropTypes.bool
};
SimpleSignupFormComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
export default SimpleSignupFormComponent;